import { post, put, get, patch, delete as remove } from 'axios'

const URL = '/polls'

export const saveDraft = poll =>
  poll.draft_id
    ? put(`/polls/drafts/${poll.draft_id}`, poll)
    : post(`/polls/drafts`, poll)
export const getDraft = id => get(`/polls/drafts/${id}`)
export const save = poll => post(`/polls`, poll)
export const getReceivers = (accessLevel, company, groups) => {
  let url = `/polls/receivers?access_level=${accessLevel}&company=${company}`
  if (!company) {
    url = url + `&groups=${groups.map(groups => groups._id).toString()}`
  }
  return get(url)
}
export const getPollList = (owner, status, limit, offset) =>
  get(
    `/polls/${owner}/${status.toLowerCase()}?limit=${limit}&offset=${offset}`
  ).catch(() => ({
    data: { polls_summary: [] },
  }))
export const patchCloseCustomPoll = id =>
  patch(`/polls/${id}`, { status: 'closed' })
export const deleteDraft = id => remove(`/polls/drafts/${id}`)
export const getPollReport = (pollId, groupId) =>
  get(`${URL}/${pollId}/reports/groups/${groupId || ''}`)
export const getPollGroups = pollId => get(`${URL}/${pollId}/groups/`)
export const getPollSurvey = pollId =>
  get(`${URL}/${pollId}/survey/?_=${new Date().getTime()}`)
export const savePollSurvey = (pollId, pollSurvey) =>
  post(`${URL}/${pollId}/survey/`, pollSurvey)

export const getOnGoing = () =>
  get('/polls/my/ongoing').then(({ data }) => data.polls_summary)

export const duplicateCustomPoll = id => post(`${URL}/${id}/duplicate`)

export default {
  getPollGroups,
  getDraft,
  getPollReport,
  getReceivers,
  save,
  saveDraft,
  getPollSurvey,
  savePollSurvey,
  getPollList,
  patchCloseCustomPoll,
  deleteDraft,
  duplicateCustomPoll,
}
